/* eslint-disable no-shadow */
const state = {
  accessToken: "",
  refreshToken: ""
};

const getters = {
  getToken: state => state.accessToken,
  getRefreshToken: state => state.refreshToken
};

const mutations = {
  setTokenMutation: (state, payload) => {
    state.accessToken = payload;
  },
  setRefreshTokenMutation: (state, payload) => {
    state.refreshToken = payload;
  },
  clearAdminAuthMutation: state => {
    state.accessToken = "";
    state.refreshToken = "";
  }
};

const actions = {
  setToken: ({ commit }, payload) => {
    commit("setTokenMutation", payload);
  },
  setRefreshToken: ({ commit }, payload) => {
    commit("setRefreshTokenMutation", payload);
  },
  clearCredentials: ({ commit }) => {
    commit("clearAdminAuthMutation");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
